import { Col, Row } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { errorCatch, POST } from 'fennec-ui';
import "react-lightbox-pack/dist/index.css";
import { useAuth } from 'fennec-ui';
import PageLayout from '../../components/PageLayout';
import { Tabs } from 'antd';
import Account from '../../components/Account';
import { useState } from 'react';
import { useLocaladminContext } from '../../../common/Context';

dayjs.locale('ru');

var _ = require('lodash');


export default function Accounts(props) {
	const auth = useAuth();
	const dispatch = useDispatch();

	const meta = useSelector(state => state.meta);

	const user = useSelector(state => state.home.user);
	const role = useSelector(state => state.home.role, () => { });
	const role_by_id = useSelector(state => state.home.role_by_id);
	const role_by_name = useSelector(state => state.home.role_by_name);

	const [akkaunti, setAkkaunti] = useState([]);

	const { ctx } = props;
	useEffect(() => {
		if(ctx){
			POST(auth, "/api/akkaunti/byowner", 
			ctx,
			// {
			// 	// userID
			// 	// organizatorFederatsiyaID
			// 	// organizatorShkolaID
			// 	// organizatorMeropriyatiyaID
			// 	organizatorRegionalnoeOtdelenieID: ctx?.ID
			// 	// meropriyatieID
			// 	// userLockID
			// }, 
			({ data }) => {
				setAkkaunti(data?.sort((a,b)=>a?.akkauntType?.enumAccountTypeID-b?.akkauntType?.enumAccountTypeID))
			}, errorCatch)
		}
	}, [ctx]);

	// akkauntTypeID
	// 1	Счет федерации (Основной)
	// 2	Счет пользователя (Основной)
	// 3	Счет регионального отделения (Основной)
	// 4	Счет организатора (Основной)
	// 5	Счет школы (Основной)
	// 6	Счет мероприятия (Основной)
	// 8	Счет федерации (Накопительный)
	// 9	Счет пользователя (Накопительный)
	// 10	Счет регионального отделения (Накопительный)
	// 11	Счет организатора (Накопительный)
	// 12	Счет школы (Накопительный)
	// 13	Счет мероприятия (Накопительный)

	const items = akkaunti?.map((e, i) => ({
		key: i,
		label: (<div>
			<div style={{ fontSize: "12px", color: "grey" }}>
				{(e?.akkauntType?.enumAccountTypeID == 1) && <span>Основной счет</span>}
				{(e?.akkauntType?.enumAccountTypeID == 2) && <span>Накопительный счет</span>}
			</div>
			<div>
				<span>№{e?.nomerAkkaunta}</span>
			</div>
		</div>),
		children: <Account key={i} auth={auth} account={e} />,
	}))

	return (
		<PageLayout /*hideBreadcrumbs={true}*/>
			<div style={{ backgroundColor: "white", borderRadius: "4px" }}>
				<div style={{ padding: "10px" }}>
					<Row gutter={[5, 5]} style={{ paddingBottom: "20px" }}>
						<Col span={24}>
							<Tabs defaultActiveKey="1" items={items} />
						</Col>
					</Row>
				</div>
			</div>
		</PageLayout>
	);
}
